import React from "react";
import { Modal, Form, Input, Collapse } from "antd";
import { BusinessPartnerType } from "../types";

const { Panel } = Collapse;

interface RejectBPProps {
  businessPartner: BusinessPartnerType;
  close: () => any;
  rejectBusinessPartner: (remarks: string) => any;
}
interface RejectBPState {
  remarks: string;
  remarksError: boolean;
}

class RejectBusinessPartners extends React.Component<
  RejectBPProps,
  RejectBPState
> {
  constructor(props) {
    super(props);
    this.state = {
      remarks: "",
      remarksError: false,
    };
  }
  onRemarkChange = (e) => {
    this.setState({ remarks: e.target.value });
  };
  rejectBusinessPartner = () => {
    if (this.state.remarks === "") {
      this.setState({ remarksError: true });
    } else {
      this.props.rejectBusinessPartner(this.state.remarks);
    }
  };

  render() {
    const { businessPartner } = this.props;
    return (
      <Modal
        title={`Reject Business Partner "${businessPartner.bpName}"`}
        visible
        width={500}
        onOk={this.rejectBusinessPartner}
        onCancel={this.props.close}
        className="bp-reject-modal"
      >
        <Form>
          <Form.Item
            label="Remarks"
            required
            validateStatus={this.state.remarksError ? "error" : ""}
            help={this.state.remarksError ? "This is a required field" : ""}
          >
            <Input.TextArea
              value={this.state.remarks}
              onChange={this.onRemarkChange}
              autoFocus
            />
          </Form.Item>
        </Form>
        {businessPartner.bpRejectComment.length > 0 && (
          <div className="reject-history">
            <Collapse bordered={false}>
              <Panel
                showArrow={true}
                header={`Reject History (${
                  businessPartner.bpRejectComment.length
                })`}
                key="1"
              >
                {businessPartner.bpRejectComment.map((item) => {
                  return (
                    <div className="reject-hisotry___item" key={item.brcId}>
                      {item.brcComment}
                    </div>
                  );
                })}
              </Panel>
            </Collapse>
          </div>
        )}
      </Modal>
    );
  }
}

export default RejectBusinessPartners;
